import type { CompanySheet } from '@/types/category';

interface CompanyCardProps {
  company: CompanySheet;
  onClick: () => void;
  sectorName?: string;
}

function resolveLogoUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const value = url.trim();
  if (!value) return null;
  if (value.startsWith("http://") || value.startsWith("https://") || value.startsWith("/")) {
    return value;
  }
  if (value.startsWith("logos/")) {
    return `/${value}`;
  }
  return `/logos/${value}`;
}

export function CompanyCard({ company, onClick, sectorName }: CompanyCardProps) {
  const logoSrc = resolveLogoUrl(company.logo_url);
  const displayName = company.display_name || company.title;

  const handleLogoError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    const image = event.currentTarget;
    const currentSrc = image.getAttribute('src') ?? '';
    if (currentSrc.includes('_capi.')) {
      image.src = currentSrc.replace('_capi.', '_cpi.');
      return;
    }
    image.style.display = 'none';
    image.nextElementSibling?.classList.remove('hidden');
  };

  return (
    <button
      onClick={onClick}
      className="bg-white h-[305px] rounded-[16px] overflow-hidden text-left transition-colors border border-peach-1 hover:border-pif-green"
    >
      {sectorName && (
        <p className="px-[19px] pt-[23px] text-[12px] font-medium text-pif-green uppercase tracking-[2px] leading-none">
          {sectorName}
        </p>
      )}

      <div className="h-[149px] mt-[23px] flex items-center justify-center px-5 py-2 overflow-hidden">
        {logoSrc ? (
          <img
            src={logoSrc}
            alt={displayName}
            className="w-full h-full object-cover"
            onError={handleLogoError}
          />
        ) : null}
        <div
          className={`w-full h-full bg-peach rounded-md flex items-center justify-center ${logoSrc ? 'hidden' : ''}`}
        >
          <span className="text-[32px] font-bold text-pif-green">
            {displayName.charAt(0)}
          </span>
        </div>
      </div>

      <div className="px-[19px] pt-6">
        <p className="text-[19px] font-bold text-grey-black tracking-[0.3px] leading-tight line-clamp-2">
          {displayName}
        </p>
      </div>
    </button>
  );
}
